import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsuarioServiceProvider } from '../index.providers';
import { LanguageService } from '../language-service/language.service';

@Injectable()
export class languageInterceptor implements HttpInterceptor {
  language:string = "es";

  constructor( private languageService: LanguageService,) {
    this.subLanguageConfig();
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let modifiedReq: HttpRequest<any> = req;

    if (req.method === 'GET') {
      modifiedReq = req.clone({
        params: (req.params || new HttpParams())
        .set('userLanguage',  this.language)
      });

    } else if (req.body instanceof FormData) {
      // Un `FormData` no se puede desestructurar (`{...formData}` da `{}` y se
      // pierde el archivo): hay que copiarlo campo por campo y añadir el idioma
      // como un campo más del multipart. Se copia en vez de mutar el original
      // porque el interceptor puede re-ejecutarse en un reintento y duplicaría
      // las llaves. Mismo criterio que `IdByBrandInterceptor`.
      const body = new FormData();
      req.body.forEach((value, key) => body.append(key, value as any));
      body.append('userLanguage', this.language);

      modifiedReq = req.clone({ body });

    } else {
      let originalBody = req.body;
      // console.log("originalBody",typeof req.body, req.body )

      if(typeof req.body === "string") {
        try {
          const parseBody = JSON.parse(req.body);
          originalBody = parseBody;
        } catch (error) {
          console.log(error)
        }
      };

      const body = { ...originalBody,
        userLanguage: this.language
      };
      modifiedReq = req.clone({ body });
    };


    return next.handle(modifiedReq);
  }


}
